import React from 'react'

// Todo: Seperate node package for this?
import Html from '../assets/icons/html5.svg'
import Js from '../assets/icons/javascript.svg'
import Css from '../assets/icons/css3.svg'
import Node from '../assets/icons/node-dot-js.svg'
import MongoDb from '../assets/icons/mongodb.svg'
import Git from '../assets/icons/git.svg'
import GitHub from '../assets/icons/github.svg'
import NodeMon from '../assets/icons/nodemon.svg'
import VsCode from '../assets/icons/visualstudiocode.svg'
import Angular from '../assets/icons/angular.svg'
import GraphQl from '../assets/icons/graphql.svg'
import ReactIcon from '../assets/icons/react-icon.svg'
import Gatsby from '../assets/icons/gatsby.svg'

import Twitter from '../assets/icons/twitter.svg'
import DevTo from '../assets/icons/dev-dot-to.svg'
import Instagram from '../assets/icons/instagram.svg'
import LinkedIn from '../assets/icons/linkedin.svg'

import styled from 'react-emotion'
import { omit } from 'lodash'

//supported icon components
const components = {
  html: { component: Html, bg: '#E34F26' },
  js: { component: Js, bg: '#F7DF1E' },
  css: { component: Css, bg: '#1572B6' },
  node: { component: Node, bg: '#339933' },
  mongo: { component: MongoDb, bg: '#47A248' },
  git: { component: Git, bg: '#F05032' },
  github: { component: GitHub, bg: '#181717' },
  nodeMon: { component: NodeMon, bg: '#76D04B' },
  vscode: { component: VsCode, bg: '#007ACC' },
  angular: { component: Angular, bg: '#DD0031' },
  graphql: { component: GraphQl, bg: '#E10098' },
  react: { component: ReactIcon, bg: '#61DAFB' },
  gatsby: { component: Gatsby, bg: '#663399' },
  twitter: { component: Twitter, bg: '#1DA1F2' },
  devto: { component: DevTo, bg: '#0A0A0A' },
  linkedin: { component: LinkedIn, bg: '#0077B5' },
  instagram: { component: Instagram, bg: '#E4405F' },
}
const Tag = styled('li')`
  color: #fff;
  padding: 5px;
  background-color: ${props => (props.bg ? props.bg : '#999')};
  margin-right: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: ${props => (props.br ? props.br : '25%')};
  cursor: pointer;
  box-shadow: 2px 2px 3px 0 hsla(0, 0%, 0%, 0.3);
`
//Todo: change font of tagname
export const StyledIconTag = ({ tag, br }) => {
  const TagName = components[tag].component
  const bg = components[tag].bg
  return (
    <Tag br={br} bg={bg}>
      <TagName
        style={{
          fill: 'currentColor',
          height: '24px',
          width: '24px',
        }}
      />
    </Tag>
  )
}

export const StyledIconTagLink = props => {
  let { href } = props
  let propsForIcon = omit(props, ['href'])
  return (
    <a href={href} target="_blank" rel="noopener noreferrer">
      <StyledIconTag {...propsForIcon} />
    </a>
  )
}
